import React from "react";
import { EmojiIcon } from "../comp/EmojiIcon";
import { Icon } from "../comp/Icon";

export class EmojiPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: true
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({ open: !this.state.open });
    }


    render() {
        
        // render
        var items = [];

        this.props.items.map((item, i) => {
            items.push(
                <EmojiIcon collection={this.props.collection} section={this.props.section} icon={item} key={i} add={this.props.add} tip={this.props.tip} />
            );
        }); 


        // if empty, display error
        if(items.length == 0) {
            items.push(
                <span className="error" key={0}>No items</span>
            );
        }


        // open / close
        var classes = "section closed";

        if(this.state.open) {
            classes = "section";
        }


        return (
            <div className={classes}>
                <h3 onClick={this.toggle}>
                    {this.props.title} 
                    { (this.state.open) ? <Icon type="fa-chevron-up" /> : <Icon type="fa-chevron-down" /> }
                </h3>

                {items}
            </div>
        );
    }
}


EmojiPanel.defaultProps = {
    title: "-",
    section: "",
    items: []
};
